<template>
  <div class="select-main" :style="{ 'width': width }" v-clickoutside="outsideClose">
    <i :class="['el-icon-arrow-up select-icon', showList ? 'select-icon-rotate-1' : 'select-icon-rotate']"></i>
    <input type="text" readonly class="input-style" v-model="showValue.label" @click="showListClick()" :style="{ 'width': width }"/>
    <ul class="select-list" v-if="showList">
      <li v-for="(item, index) in optionList" :key="index" @click="chooseOption(item)" :style="{ 'background': showValue.value == item.value ? 'rgba(0, 79, 177, .1)' : ''} ">{{ item.label }}</li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      required: false,
      default: '150px'
    },
    optionList: {
      type: Array,
      required: true,
      default: () => {
        return [];
      }
    },
    showValue: {
      type: Object,
      required: true,
      default: () => {
        return {
          value: 0,
          label: ''
        };
      }
    }
  },
  computed: {
    inputValue() {
      return this.showValue.label;
    },
  },
  data() {
    return {
      showList: false,
    }
  },
  methods: {
    chooseOption(val) {
      this.$emit('getOption', val);
      this.showListClick();
    },
    showListClick() {
      this.showList = !this.showList;
    },
    outsideClose() {
      if (this.showList) {
        this.showList = !this.showList;
      }
    },
  },
}
</script>

<style scoped lang="scss">
.select-main {
    display: inline-block;
    position: relative;
    box-sizing: border-box;
    z-index: 20;
    .input-style {
      width: 100%;
      height: 34px;
      padding: 5px 9px;
      box-sizing: border-box;
      background: #FFFFFF;
      border-radius: 5px;
      border: 1px solid #DADADA;

      font-size: 12px;
      font-family: 'MicrosoftYaHei';
      color: #777777;
      line-height: 16px;
    }

    .input-style:hover {
      cursor: pointer;
    }

    .select-icon {
      position: absolute;
      top: 12px;
      left: 85%;
      // font-size: 14px;
      color: #777;
    }

    .select-icon-rotate {
      transition: transform .3s;
      transform: rotate(180deg);
    }

    .select-icon-rotate-1 {
      transition: transform .3s;
      transform: rotate(0deg);
    }

    .select-list {
      position: absolute;
      top: 30px;
      box-sizing: border-box;
      width: 100%;
    // height: 95px;
      background: #FFFFFF;
      border-radius: 5px;
      border: 1px solid #DADADA;
      border-top-left-radius: 0;
      border-top-right-radius: 0;
      border-top: none;

      li {
        padding: 5px 9px;
        line-height: 16px;
        height: 28px;
        box-sizing: border-box;
      }

      li:hover {
        cursor: pointer;
        background: rgba(0, 79, 177, .1);
      }
    }
}

</style>



// WEBPACK FOOTER //
// src/components/userCenter/myInfo/byEnSelect.vue